// script.js (polyhedron index.html) ~sdg
'use strict'
console.time('LoadTime')
import './normalize.css'
import './style.css'
import * as THREE from 'three'
//import { LatheGeometry } from 'three/examples/src/geometries/CapsuleGeometry.js'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js'
// Canvas
const canvas = document.querySelector('canvas.webgl')
// Scene
const scene = new THREE.Scene()
// Axes Helper
//const axesHelper = new THREE.AxesHelper(3)
//scene.add(axesHelper)
/**
 * Sizes
 */
const sizes = {
  width: window.innerWidth,
  height: window.innerHeight
}
// Resize
window.addEventListener('resize', () =>
{
  // Update sizes
  sizes.width = window.innerWidth
  sizes.height = window.innerHeight
  // Update camera
  camera.aspect = sizes.width / sizes.height
  camera.updateProjectionMatrix()
  // Update renderer
  renderer.setSize(sizes.width, sizes.height)
  renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
})

/**
 * Camera
 */
// Base camera
const camera = new THREE.PerspectiveCamera(50, sizes.width / sizes.height, 0.1, 100)
camera.position.x = 4
camera.position.y = 4
camera.position.z = 4

scene.add(camera)

// Controls
const controls = new OrbitControls(camera, canvas)
controls.enableDamping = true
controls.minDistance = 2
controls.maxDistance = 90

/**
 * Renderer
 */
const renderer = new THREE.WebGLRenderer({ canvas: canvas })
renderer.setSize(sizes.width, sizes.height)
renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))

/**
 * Polyhedron
 */

const verticesOfCube = [
  -1, -1, -1, 1, -1, -1, 1, 1, -1, -1, 1, -1,
  -1, -1, 1, 1, -1, 1, 1, 1, 1, -1, 1, 1,
];

const indicesOfFaces = [
  2, 1, 0, 0, 3, 2,
  0, 4, 7, 7, 3, 0,
  0, 1, 5, 5, 4, 0,
  1, 2, 6, 6, 5, 1,
  2, 3, 7, 7, 6, 2,
  4, 5, 6, 6, 7, 4
];
const material = new THREE.MeshNormalMaterial({flatShading: true })
const geometry = new THREE.PolyhedronGeometry(verticesOfCube, indicesOfFaces, 1, 8);
const mesh = new THREE.Mesh(geometry, material)

scene.add(mesh)

/**
 * Animate
 */
const clock = new THREE.Clock()
const animate = () =>
{
  const elapsedTime = clock.getElapsedTime()
  // Update Controls
  controls.update()
  // Rotate Polyhedron
  mesh.rotation.z = elapsedTime * 0.1
  // Render
  renderer.render(scene, camera)
  window.requestAnimationFrame(animate)
}
animate()
console.timeEnd('LoadTime')
// EOF script.js (polyhedron index.html) ~sdg